import React from 'react';
import proptypes from 'prop-types';
const { node, string } = proptypes;

const ZoneCard = ({ children, className }) => {
  return <div className={className}>{children}</div>;
};

ZoneCard.propTypes = {
  children: node.isRequired,
  className: string,
};

ZoneCard.defaultProps = {
  className: 'zone-card',
};

export default ZoneCard;
